import { Box, Chip, ChipProps, Typography } from "@mui/joy";

type RouteLabelChipProps = Omit<ChipProps, "children" | "slotProps"> & {
  name: string;
  // A grouped label shows its group's name first, split off by a divider.
  groupName?: string | null;
};

/** A label as it appears on a route. */
export default function RouteLabelChip({ name, groupName, ...props }: RouteLabelChipProps) {
  return (
    <Chip
      variant="soft"
      color="neutral"
      {...props}
      // Stretching the label lets the group's divider run the full height of
      // the chip.
      slotProps={{
        label: {
          sx: { display: "flex", alignSelf: "stretch", alignItems: "center", color: "neutral.900" },
        },
      }}
    >
      {groupName ? (
        <>
          <Box
            component="span"
            sx={{
              alignSelf: "stretch",
              display: "flex",
              alignItems: "center",
              pr: 0.75,
              mr: 0.75,
              borderRight: "1px solid",
              borderColor: "neutral.outlinedBorder",
              color: "text.tertiary",
            }}
          >
            {groupName}
          </Box>
          <Typography component="span" textColor="neutral.700" fontSize="inherit">
            {name}
          </Typography>
        </>
      ) : (
        name
      )}
    </Chip>
  );
}
